import { render, staticRenderFns } from "./selectRegion.vue?vue&type=template&id=3f35f096&scoped=true"
import script from "./selectRegion.vue?vue&type=script&lang=js"
export * from "./selectRegion.vue?vue&type=script&lang=js"
import style0 from "@/styles/pc.css?vue&type=style&index=0&id=3f35f096&prod&scoped=true&lang=css&external"
import style1 from "./selectRegion.vue?vue&type=style&index=1&id=3f35f096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f35f096",
  null
  
)

export default component.exports